import React from "react";

// Building blocks for the grouped "detail card" layout: a small uppercase
// section header, then stacked fields with a muted label above each value.
// Pass `inline` to lay a section's short fields out in a wrapping row
// (use stacked while editing so inputs have room).
export const DetailSection = ({ title, first, inline, children }) => (
  <div style={{ marginTop: first ? 0 : 12, paddingTop: first ? 0 : 10, borderTop: first ? "none" : "1px solid rgba(0,0,0,0.08)" }}>
    <div style={{ fontSize: "0.7rem", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: "#5a6268", marginBottom: 6 }}>{title}</div>
    <div style={inline ? { display: "flex", flexWrap: "wrap", columnGap: 28 } : undefined}>{children}</div>
  </div>
);

// `empty` shows a muted dash in place of the value; `hint` is a small note under it.
export const DetailField = ({ label, hint, empty, children }) => (
  <div style={{ marginBottom: 8 }}>
    <div style={{ fontSize: "0.72rem", color: "#6c757d", lineHeight: 1.2 }}>{label}</div>
    <div style={{ lineHeight: 1.35, color: "#212529" }}>{empty ? <span style={{ color: "#6c757d" }}>—</span> : children}</div>
    {hint ? <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: 2 }}>{hint}</div> : null}
  </div>
);

